import { useAsyncRead } from './useAsyncRead';
import { trendsService } from '@/core/services/trendsService';
import type { Trend } from '@/core/models/trend';
const empty: Trend[] = [];
const load = () => trendsService.list();
export function useTrends() {
  const result = useAsyncRead(load, 'trends', empty);
  return { ...result, trends: result.data };
}

export type TrendsHook = ReturnType<typeof useTrends>;
